(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const stickyHeader = document.querySelector('sticky-header');
    if(stickyHeader) {
      stickyHeader.setupWindowResizeEvent();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sor-store-film"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('sor-store-film')) {
  customElements.define('sor-store-film', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      const video = this.querySelector('video');
      const button = this.querySelector('button');
      if (!video || !button) return;
      this.dataset.ready = 'true';
      button.hidden = !video.paused;
      video.play().then(() => { button.hidden = true; }).catch(() => { button.hidden = false; });
      button.addEventListener('click', async () => {
        button.hidden = true;
        try { await video.play(); video.focus({preventScroll: true}); }
        catch { button.hidden = false; }
      });
      video.addEventListener('play', () => { button.hidden = true; });
      video.addEventListener('ended', () => { button.hidden = false; });
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
